import { render, staticRenderFns } from "./CTAHeader.vue?vue&type=template&id=437b475c&scoped=true"
import script from "./CTAHeader.vue?vue&type=script&lang=js"
export * from "./CTAHeader.vue?vue&type=script&lang=js"
import style0 from "./CTAHeader.vue?vue&type=style&index=0&id=437b475c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b475c",
  null
  
)

export default component.exports